import { render, staticRenderFns } from "./padh5.vue?vue&type=template&id=3cef8018&scoped=true&"
import script from "./padh5.vue?vue&type=script&lang=js&"
export * from "./padh5.vue?vue&type=script&lang=js&"
import style0 from "./padh5.vue?vue&type=style&index=0&id=3cef8018&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef8018",
  null
  
)

export default component.exports